import * as React from 'react'

import { BottomDrawer } from '~ui/components/content/Drawer/BottomDrawer'
import { ModalBody } from '~ui/components/content/Modal/components/ModalBody'
import { Modal } from '~ui/components/content/Modal/Modal'
import { Box, Flex, Grid } from '~ui/components/layout/Box'
import { Stack } from '~ui/components/layout/Stack'
import { TSingleSpace } from '~ui/styleGuide/spaces'
import { getGridPlacement } from '~ui/utils/gridUtils'

import { useLayoutCtx } from '../../../config/contexts/LayoutProvider'
import { useAddonDetailControlCtx } from '../contexts/AddonDetailProvider'
import { AddonDetailCloseButton } from './AddonDetailCloseButton'
import { AddonDetailImage } from './AddonDetailImage'
import { AddonDetailInfo } from './AddonDetailInfo'
import { AddonDetailPrice } from './AddonDetailPrice'

type TProps = NoChildren

const modalVerticalSpace: TSingleSpace = `large`
const modalHorizontalSpace: TSingleSpace = `extraLarge`

/**
 * Modal or mobile drawer with addon detail.
 * *main-dish type of addons*
 */
export const AddonDetailResponsiveContent: React.FC<TProps> = () => {
  const { closeAddonDetail } = useAddonDetailControlCtx()
  const { isMobile } = useLayoutCtx()

  if (isMobile) {
    return (
      <BottomDrawer
        isOpen
        onClose={closeAddonDetail}
        headerProps={{
          closeBtnBgColor: `tertiary`,
          closeBtnOffset: { top: `0.5rem`, left: `0.5rem` },
        }}
        footerProps={{
          padding: 'medium',
          content: <AddonDetailCloseButton />,
        }}
      >
        <Box shadow={`medium`}>
          <AddonDetailImage />
        </Box>
        <Stack padding={{ horizontal: `large`, vertical: `smallMedium` }} spacing={`medium`}>
          <AddonDetailInfo />
          <AddonDetailPrice />
        </Stack>
      </BottomDrawer>
    )
  }

  return (
    <Modal isOpen onClose={closeAddonDetail} size={`md`} overlayZIndex={100}>
      <ModalBody
        padding={{
          bottom: modalVerticalSpace,
          left: modalHorizontalSpace,
          right: modalHorizontalSpace,
          top: `extraLarge`,
        }}
      >
        <Grid
          as={`section`}
          alignItems={`start`}
          rowGap={modalVerticalSpace}
          columnGap={modalHorizontalSpace}
          gridTemplateRows={`min-content 1fr auto`}
          gridTemplateColumns={`auto min-content`}
        >
          <AddonDetailInfo />
          <Box gridColumn={2} gridRow={`1 / span 2`}>
            <AddonDetailImage />
          </Box>

          <Flex
            {...getGridPlacement({ row: 3, col: `all` })}
            justifyContent={`space-between`}
            alignItems={`center`}
          >
            <AddonDetailPrice />
            <AddonDetailCloseButton />
          </Flex>
        </Grid>
      </ModalBody>
    </Modal>
  )
}
